import NotifyComponent from './NotifyComponent';
export default NotifyComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/notify/index.ts
// module id = 1015
// module chunks = 0 1 2 4 5 6 18 19 20 21